import React        from 'react';
import PropTypes    from 'prop-types';
import Translations from '../../../utils/Translations';

const Fact = ({iconClass, translationKey, value}) => (
    <>
        <div className="context-box__tile--property">
            <span className={`context-box__tile--property__icon icon-actor ${iconClass} -size-md`}/>
            <span className="context-box__tile--property__caption">
                {Translations.get(translationKey)}
            </span>
            <span className = {`context-box__tile--property__value ${iconClass==="-icon-fact-languages" ? "-country-label" : ""}`}>
                {value}
            </span>
        </div>
    </>
);

Fact.propTypes = {
    iconClass:      PropTypes.string,
    translationKey: PropTypes.string,
    value:          PropTypes.any
};

export default Fact;
